import { Input } from 'antd';
import type { ComponentProps } from 'react';
import { Search2LineIcon } from '../../icons';
import { Item } from '../item';

type InputP = Omit<ComponentProps<typeof Input>, 'css'> & Record<string, unknown>;

type ItemP<Values> = Omit<ComponentProps<typeof Item<Values>>, 'children'>;

type P<Values> = {
  hasSearch?: boolean;
  input?: InputP;
  item: ItemP<Values>;
};

// TODO: font size, color, prefix/suffix margin isn't correct
/**
 * @deprecated Use Input instead with Form.Item
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
const TextInput = <Values = any,>({ hasSearch, input, item }: P<Values>) => (
  <Item<Values> {...item}>
    <Input
      allowClear={hasSearch}
      prefix={hasSearch ? <Search2LineIcon type="default" /> : undefined}
      size="large"
      {...input}
    />
  </Item>
);

export default TextInput;
